<template>
  <div :style="pageSetInfo.listStyleSet.listPageCardBoxStyleSet?pageSetInfo.listStyleSet.listPageCardBoxStyleSet.styleSetCode:''" kwName="listPageCardBoxStyleSet">
    <ve-pie v-if="(!pageSetInfo.listStyleSet.pieChartStyleSet || !pageSetInfo.listStyleSet.pieChartStyleSet.chartType || pageSetInfo.listStyleSet.pieChartStyleSet.chartType == '饼图')" :data="globalChartData" :settings="pieChartSettings" :extend="pieChartOptions" :height="(pageSetInfo.listStyleSet.listPageCardBoxStyleSet&&pageSetInfo.listStyleSet.listPageCardBoxStyleSet.height)?(pageSetInfo.listStyleSet.listPageCardBoxStyleSet.height):'400px'" :width="pageSetInfo.listStyleSet.listPageCardBoxStyleSet.width?(pageSetInfo.listStyleSet.listPageCardBoxStyleSet.width):'auto'"></ve-pie>
    <ve-radar v-else-if="pageSetInfo.listStyleSet.pieChartStyleSet.chartType=='雷达图'" :data="globalChartData" :extend="pieChartOptions" :height="(pageSetInfo.listStyleSet.listPageCardBoxStyleSet && pageSetInfo.listStyleSet.listPageCardBoxStyleSet.height)?(pageSetInfo.listStyleSet.listPageCardBoxStyleSet.height):'400px'" :width="pageSetInfo.listStyleSet.listPageCardBoxStyleSet.width?(pageSetInfo.listStyleSet.listPageCardBoxStyleSet.width):'auto'"></ve-radar>
    <ve-line v-else-if="pageSetInfo.listStyleSet.pieChartStyleSet.chartType=='折线图'" :data="globalChartData" :extend="pieChartOptions" :height="(pageSetInfo.listStyleSet.listPageCardBoxStyleSet && pageSetInfo.listStyleSet.listPageCardBoxStyleSet.height)?(pageSetInfo.listStyleSet.listPageCardBoxStyleSet.height):'400px'" :width="pageSetInfo.listStyleSet.listPageCardBoxStyleSet.width?(pageSetInfo.listStyleSet.listPageCardBoxStyleSet.width):'auto'"></ve-line>
  </div>
</template>

<script>
import Vue from 'vue'
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
// 列表的按钮组件
import kw_btn_array from '@/components/look/kw_btn_array.vue';
import VCharts from 'v-charts'
Vue.use(VCharts);

export default {
  name: 'kw_list_pie.vue',
  props: {
    pageSetInfo: {
      type: Object,
      value: null
    },
    listFieldSet: {
      type: Array,
      value: null
    },
    //列表数据全部显示
    dataList: {
      type: Array,
      value: null
    },
    //单一一条数据进行显示
    dataInfo: {
      type: Object,
      value: null
    },
    initDataIndex: {
      type: Number,
      value: 0
    },
    previewVisitSource:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      pieChartOptions:{
        legend:{
          show:true,
          // type: 'scroll',
          // orient: 'vertical',
          left: 'right',
          top:'10px'
        },
        series:{
          type:'pie',
          radius: [0, 0],
          center:['0%',0],
          label:{
            show:false
          }
        }
      },
      pieChartSettings:{
        dimension:"名称",
        metrics:"值"
      },
      globalChartData:[],
      ifLoad:false
    };
  },
  created() {
    var that = this;
    var pieChartStyleSet = null;
    if(that.pageSetInfo.listStyleSet) {
      pieChartStyleSet = that.pageSetInfo.listStyleSet.pieChartCommonStyleSet;
    }
    var chartTypeEn = "";
    if(pieChartStyleSet && pieChartStyleSet.chartType == "雷达图") {
      chartTypeEn = "radar";
    } else if(pieChartStyleSet && pieChartStyleSet.chartType == "折线图") {
      chartTypeEn = "line";
    } else {
      chartTypeEn = "pie";
    }
    var pieChartOptions = {
      title:{
        text:"",
        show:(!pieChartStyleSet || pieChartStyleSet.titleIfShow != 2)?true:false,
        left: (pieChartStyleSet && pieChartStyleSet.titleLeft)?pieChartStyleSet.titleLeft:'10px',
        top: (pieChartStyleSet && pieChartStyleSet.titleTop)?pieChartStyleSet.titleTop:'middle',
        right: (pieChartStyleSet && pieChartStyleSet.titleRight)?pieChartStyleSet.titleRight:'auto',
        buttom: (pieChartStyleSet && pieChartStyleSet.titleButtom)?pieChartStyleSet.titleButtom:'auto',
        textStyle:{
          fontSize:(pieChartStyleSet && pieChartStyleSet.titleFontSize)?pieChartStyleSet.titleFontSize:"14px",
          color:(pieChartStyleSet && pieChartStyleSet.titleFontColor)?pieChartStyleSet.titleFontColor:'#333'
        },
      },
      legend:{
        show:(!pieChartStyleSet || pieChartStyleSet.legendIfShow != 2)?true:false,
        type: 'scroll',
        orient: (pieChartStyleSet && pieChartStyleSet.legendOrient)?pieChartStyleSet.legendOrient:'horizontal',
        left: (pieChartStyleSet && pieChartStyleSet.legendLeft)?pieChartStyleSet.legendLeft:'right',
        top: (pieChartStyleSet && pieChartStyleSet.legendTop)?pieChartStyleSet.legendTop:'10px',
        right: (pieChartStyleSet && pieChartStyleSet.legendRight)?pieChartStyleSet.legendRight:'auto',
        buttom: (pieChartStyleSet && pieChartStyleSet.legendButtom)?pieChartStyleSet.legendButtom:'auto',
        itemWidth:(pieChartStyleSet && pieChartStyleSet.legendItemWidth)?pieChartStyleSet.legendItemWidth:15,
        itemHeight:(pieChartStyleSet && pieChartStyleSet.legendItemHeigth)?pieChartStyleSet.legendItemHeigth:7,
        textStyle:{
            fontSize:(pieChartStyleSet && pieChartStyleSet.legendFontSize)?pieChartStyleSet.legendFontSize:12,
            color:(pieChartStyleSet && pieChartStyleSet.legendFontColor)?pieChartStyleSet.legendFontColor:'#333'
        }
      },
      series:{
        type:chartTypeEn,
        radius: (pieChartStyleSet && pieChartStyleSet.seriesRadius)?eval(pieChartStyleSet.seriesRadius):[0, '50%'],
        center: (pieChartStyleSet && pieChartStyleSet.seriesCenter)?eval(pieChartStyleSet.seriesCenter):['70%','50%'],
        label:{
            show: (pieChartStyleSet && pieChartStyleSet.seriesLabelIfShow)?pieChartStyleSet.seriesLabelIfShow:false,
            position:(pieChartStyleSet && pieChartStyleSet.seriesLabelPosition)?pieChartStyleSet.seriesLabelPosition:'inside',
            formatter:(pieChartStyleSet && pieChartStyleSet.seriesLabelFormatter)?pieChartStyleSet.seriesLabelFormatter:'{c}个'
        }
      }
    }
    that.pieChartOptions = pieChartOptions;
  },
  mounted() {
    this.updataDataList();
  },
  watch:{
    dataList:function(newVal){
      this.updataDataList();
    }
  },
  computed:{
  },
  components: {
    kw_btn_array
  },
  methods: {
    updataDataList() {
      //选择id
      var that = this;
      var dataList = that.dataList;
      var pieChartStyleSet = null;
      if(that.pageSetInfo.listStyleSet) {
        pieChartStyleSet = that.pageSetInfo.listStyleSet.pieChartCommonStyleSet;
      }
      var globalChartData = {
        columns:['名称'],
        rows:[]
      };
      if(pieChartStyleSet && (pieChartStyleSet.chartType == "雷达图"||pieChartStyleSet.chartType == "折线图")) {
        for (let index = 1; index < that.listFieldSet.length; index++) {
          const fieldInfo = that.listFieldSet[index];
          if(!fieldInfo.styleSet || fieldInfo.styleSet.cssStyle != 5) {
            globalChartData.columns.push(fieldInfo.fieldCnName);
          }
        }
      } else {
        globalChartData.columns.push("值");
      }
      
      // 获取最后一条数据 进行百分比的计算
      if (dataList.length>=0) {
        dataList.forEach(dataInfo => {
          var chartData = {};
          if(pieChartStyleSet && (pieChartStyleSet.chartType == "雷达图"||pieChartStyleSet.chartType == "折线图")) {
            var oneJson = {};
            oneJson["名称"] = dataInfo.NAME?dataInfo.NAME:dataInfo[that.listFieldSet[0].fieldAliasName];
            for (let index = 1; index < that.listFieldSet.length; index++) {
              const fieldInfo = that.listFieldSet[index];
              if(!fieldInfo.styleSet || fieldInfo.styleSet.cssStyle != 5) {
                oneJson[fieldInfo.fieldCnName] = dataInfo[fieldInfo.fieldAliasName];
              }
            }
            globalChartData.rows.push(oneJson);
          } else {
            globalChartData.rows.push({
              "名称":dataInfo.NAME?dataInfo.NAME:dataInfo[that.listFieldSet[0].fieldAliasName],
              "值":dataInfo.VALUE?dataInfo.VALUE:dataInfo[that.listFieldSet[1].fieldAliasName]
            });
          }
        });
        console.log("globalChartData=================pie=====================",globalChartData);
        this.globalChartData = globalChartData;
        that.ifLoad = true;
      }
    },
    /**
     * 列表数据点击时 进行跳转
     */
    listDataClick(dataInfo) {
      pageUtils.listDataClick(this, dataInfo);
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo) {
      pageUtils.dataButtonClick(this,detail,dataInfo);
    },
    /**
     * 调用列表数据刷新方法
     */
    initLoadDataInfo: function () {
      this.$emit("refreshevent");
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.totalProgress {
    width:100%;
    height:10px;
    background:#F0F0F0;
    border-radius: 8px;
    margin-top:55px;
}

.currentProgress {
    width:30%;
    height:100%;
    background:#FEB834;
    border-radius: 8px;
}

.selectionProgress {
    position:relative;
}

.selectionProgress .selItem {
    font-size: 12px;
    color:#0E0E0E;
    line-height:1.5;
    text-align: right;
    position:absolute;
}

.selectionProgress .selItem:nth-child(1) {
    width:0%;
}

.selectionProgress .selItem:nth-child(2) {
    width:15.15%;
}

.selectionProgress .selItem:nth-child(2):before,
.selectionProgress .selItem:nth-child(3):before,
.selectionProgress .selItem:nth-child(4):before,
.selectionProgress .selItem:nth-child(5):before{
    content: ' ';
    display: block;
    width:1px;
    height:5px;
    background: #A6A6A6;
    position: absolute;
    top: -5px;
    right: 10px;
}

.selectionProgress .selItem:nth-child(3) {
    width:23.23%;
}

.selectionProgress .selItem:nth-child(4) {
    width:40.67%;
}

.selectionProgress .selItem:nth-child(5) {
    width:60.6%;
}

.selectionProgress .selItem:nth-child(6) {
    width:100%;
}

.poptit {
    position: absolute;
    top:-60px;
    left: 100%;
    transform: translate(-40px);
    width:60px;
    height:30px;
    border:1px solid #DFDFDF;
    border-radius: 5px;
    text-align: center;
    line-height: 30px;
}

.poptit img {
    width: 30px;
    height: 24px;
    position: absolute;
    left: 50%;
    top: 3px;
    transform: translate(-15px);
}

.poptit_bottom {
    top: 30px;
}

.selectionProgress .selItem:last-child .poptit {
    transform: translate(-58px);
}

.poptit:before {
    content: ' ';
    display: block;
    width:10px;
    height:10px;
    background:#fff;
    border:1px solid #DFDFDF;
    border-top:none;
    border-right:none;
    position:absolute;
    bottom:-2px;
    left:45%;
    transform: rotate(-45deg) translate(-5px);
}

.poptit_bottom:before {
    top: -5px;
    left: 38%;
    transform: rotate(135deg);
}

.currentpop {
    border:1px solid #FEB834;
}

.currentpop:before {
    border:1px solid #FEB834;
    border-top:none;
    border-right:none;
}

</style>
